import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
import { painPoints } from '../data/offer';
export function PainPoints() {
  return <section className="bg-brand-ink px-4 py-16 sm:py-24" data-id="element-83" data-mp="2lp58b04xzixw">
      <div className="mx-auto max-w-4xl" data-id="element-84" data-mp="26xmpkukp7aau">
        <header className="text-center" data-id="element-85" data-mp="2bxiy974cbpwq">
          <h2 className="font-display text-2xl font-bold sm:text-4xl" data-id="element-86" data-mp="2bwhbw6hvjgzp">
            ¿Cuánto tiempo más vas a organizar tu vida alrededor de la hinchazón?
          </h2>
          <p className="mx-auto mt-6 max-w-3xl text-slate-300" data-id="element-87" data-mp="21z37j5986inr">
            Ya probaste dietas, eliminaste alimentos y leíste todo lo que
            encontraste. No es falta de esfuerzo ni de voluntad: es que hasta
            ahora nadie te dio el orden correcto de las fases.
          </p>
          <p className="mt-4 font-semibold text-brand-light" data-id="element-88" data-mp="3idl59hadsul1">
            No necesitás eliminar más comida. Necesitás un sistema claro.
          </p>
        </header>

        <div className="mt-10 space-y-3" data-id="element-89" data-mp="3nbwfvu8i394b">
          {painPoints.map((point, index) => <motion.div key={point} initial={{
          opacity: 0,
          x: -14
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: Math.min(index * 0.04, 0.2),
          duration: 0.25,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 rounded-xl border border-red-900/70 bg-[#250c0c] p-4 sm:p-5" data-id="element-90" data-mp="1yz3tspgqzocm" data-mpi={index}>
              <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" aria-hidden="true" data-id="element-91" data-mp="1g22pl6v0ps9q" />
              <p className="text-sm leading-relaxed text-slate-200 sm:text-base" data-id="element-92" data-mp="1b4kd56hskuwz">{point}</p>
            </motion.div>)}
        </div>

        <p className="mt-12 text-center font-display text-2xl font-bold italic text-brand-gold sm:text-3xl" data-id="element-93" data-mp="1k3nxedsp3gd2">
          ¿Y si pudieras bajar la fermentación desde esta misma semana, con un
          plan que ya está armado?
        </p>
      </div>
    </section>;
}